import React from 'react';
import { cn } from '../../utils/cn';
export function InlineButtonGroup({ children, className }) {
    return (React.createElement("div", { className: cn(className, 'flex flex-row', 'border-t border-smudge', 'divide-x divide-smudge') }, children));
}
